import React from 'react';
import styles from './index.module.scss';

const Ticket = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27'>
            <defs>
                <linearGradient id='a' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'>
                    <stop offset='0' stopColor='#ea2c2f' />
                    <stop offset='1' stopColor='#8e0003' />
                </linearGradient>
            </defs>
            <g transform='translate(-32 -38.515)'>
                <path
                    d='M50.17,48.692q.079.074.152.155l.026.026a.549.549,0,0,0,.938-.394V40.068a.549.549,0,0,0-.928-.4l-.285.275a.477.477,0,0,1-.667,0h0l-1.313-1.27a.544.544,0,0,0-.758,0l-1.315,1.27a.477.477,0,0,1-.665,0l-1.313-1.269a.544.544,0,0,0-.758,0l-1.312,1.269a.477.477,0,0,1-.665,0l-1.313-1.269a.544.544,0,0,0-.758,0l-1.313,1.269a.477.477,0,0,1-.665,0l-1.313-1.269a.544.544,0,0,0-.758,0l-1.312,1.269a.477.477,0,0,1-.665,0l-.279-.27a.549.549,0,0,0-.929.4V57.129a.554.554,0,0,0,.55.558H50.736a.554.554,0,0,0,.55-.558h0a.562.562,0,0,0-.154-.387L46.908,52.3a2.472,2.472,0,0,1-.144-3.456A2.386,2.386,0,0,1,50.17,48.692Z'
                    transform='translate(0 0)'
                    fill='url(#a)'
                />
                <path
                    d='M287.951,141.551l-1.772-1.8a1.452,1.452,0,0,0-2.042,0,1.473,1.473,0,0,0-.01,2.061l.01.01,4.52,4.758a.493.493,0,0,1,.134.34v.979a.971.971,0,0,1-.964.978h-2.411a.486.486,0,0,0-.482.489v.979a2.432,2.432,0,0,0,2.411,2.446h6.75a.486.486,0,0,0,.482-.489V141.2a3.43,3.43,0,0,0-.988-2.421l-3.975-4.033a.481.481,0,0,0-.823.346v5.751a.493.493,0,0,0,.124.328l2.322,2.611a.494.494,0,0,1-.035.691h0a.477.477,0,0,1-.681-.035Z'
                    transform='translate(-236.541 -90.215)'
                    fill='#ff797b'
                />
                <path
                    d='M304.84,448h8.927a.847.847,0,0,1,.84.853v.252a.847.847,0,0,1-.84.853H304.84a.847.847,0,0,1-.84-.853v-.252A.847.847,0,0,1,304.84,448Z'
                    transform='translate(-255.607 -384.442)'
                    fill='#ff797b'
                />
                <rect
                    width='0.964'
                    height='0.979'
                    transform='translate(33.929 48.391)'
                    fill='#ff797b'
                />
                <rect
                    width='6.75'
                    height='0.979'
                    transform='translate(35.857 48.391)'
                    fill='#ff797b'
                />
                <path
                    d='M72.679,104.408a.46.46,0,0,1-.482.434H64.482a.46.46,0,0,1-.482-.434v-3.474a.46.46,0,0,1,.482-.434H72.2a.46.46,0,0,1,.482.434Z'
                    transform='translate(-30.071 -58.195)'
                    fill='#ff797b'
                />
                <path
                    d='M72.679,248.408a.46.46,0,0,1-.482.434H64.482a.46.46,0,0,1-.482-.434v-3.474a.46.46,0,0,1,.482-.434H72.2a.46.46,0,0,1,.482.434Z'
                    transform='translate(-30.071 -193.388)'
                    fill='#ff797b'
                />
            </g>
        </svg>
    );
};

export default Ticket;
